import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2cf11059&scoped=true&lang=pug&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "@views/Home/Home.styl?vue&type=style&index=0&id=2cf11059&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf11059",
  null
  
)

export default component.exports